import { Routes, Route, Navigate } from 'react-router-dom';
import { TenantProvider } from './context/TenantContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PurchaseRequestsPage from './pages/PurchaseRequestsPage';
import NewPurchaseRequestPage from './pages/NewPurchaseRequestPage';
import PurchaseRequestDetailPage from './pages/PurchaseRequestDetailPage';
import ApprovalInboxPage from './pages/ApprovalInboxPage';
import VendorRegistryPage from './pages/VendorRegistryPage';
import SavingsDashboardPage from './pages/SavingsDashboardPage';
import SuperAdminPage from './pages/SuperAdminPage';
import TenantOnboardingPage from './pages/TenantOnboardingPage';

export default function App() {
  return (
    <TenantProvider>
      <Routes>
        <Route path="/"                         element={<Navigate to="/login" replace />} />
        <Route path="/login"                    element={<LoginPage />} />
        <Route path="/dashboard"                element={<DashboardPage />} />
        <Route path="/purchase-requests"        element={<PurchaseRequestsPage />} />
        <Route path="/purchase-requests/new"    element={<NewPurchaseRequestPage />} />
        <Route path="/purchase-requests/:id"    element={<PurchaseRequestDetailPage />} />
        <Route path="/approvals"                element={<Navigate to="/approvals/inbox" replace />} />
        <Route path="/approvals/inbox"          element={<ApprovalInboxPage />} />
        <Route path="/vendors"                  element={<VendorRegistryPage />} />
        <Route path="/savings"                  element={<SavingsDashboardPage />} />
        <Route path="/superadmin"                              element={<SuperAdminPage />} />
        <Route path="/superadmin/tenants/:tenantId/onboarding" element={<TenantOnboardingPage />} />
      </Routes>
    </TenantProvider>
  );
}
